import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import { getUserRole, isAuthenticated } from "../../privateroutes/auth";
import { useDispatch, useSelector } from "react-redux";
import { base } from "../../constants/base";
import { handleLogout } from "../../redux/slices/authSlice";
import useDashboardSidebarToggle from "../../hooks/useDashboardSidebarToggle";

const SecondHeader = ({ hideMobileNav = false }) => {
  // AUTHENTICATION
  const isAuth = isAuthenticated();
  const userRole = getUserRole();
  const user = useSelector((state) => state?.AuthSlice?.user);

  const dispatch = useDispatch();
  // AUTHENTICATION
  const [showNotificationBox, setShowNotificationBox] = useState(false);
  const notificationRef = useRef(null);
  const navigate = useNavigate()

  /* On pages without a dashboard sidebar, this header's own nav becomes the
     off-canvas drawer — same hamburger, same open/close behaviour. */
  const navRef = useRef(null);
  const { sidebarOpen, closeSidebar } = useDashboardSidebarToggle(navRef);
  const asDrawer = !hideMobileNav;

  const showNotification = () => {
    setShowNotificationBox((prevState) => !prevState);
  };

  const handleClickOutside = (event) => {
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target)
    ) {
      setShowNotificationBox(false);
    }
  };

  useEffect(() => {
    if (showNotificationBox) {
      const timer = setTimeout(() => {
        window.addEventListener("click", handleClickOutside);
      }, 0);

      return () => {
        clearTimeout(timer);
        window.removeEventListener("click", handleClickOutside);
      };
    }
  }, [showNotificationBox]);

  // HANDLE LOGOUT

  const handleLogoutHere = async () => {
    const res = await dispatch(handleLogout())
    navigate("/signin");
  }

  return (
    <>
      {asDrawer && sidebarOpen && (
        <div className="dashboard-sidebar-backdrop" onClick={closeSidebar}></div>
      )}

      <nav
        className={`navbar second-header-box navbar-expand-lg navbar-header-icon${asDrawer ? ' second-header-as-drawer' : ''}`}
      >
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/images/logo.png" width={"30px"} alt="LOGO" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div
            ref={navRef}
            className="collapse navbar-collapse header-box-main"
            id="navbarSupportedContent"
          >
            <ul className={`navbar-nav ms-auto mb-2 mb-lg-0${hideMobileNav ? ' header-nav-hidden-on-mobile' : ''}`}>
              <div className="notification-box-main">
                {/* <li className="nav-item notificaiton-box" onClick={showNotification}>
                                    <a className="nav-link active" href="#"><i className="far fa-bell"></i></a>
                                    <span className='notification-countere'>20</span>
                                </li> */}

                {showNotificationBox && (
                  <div
                    ref={notificationRef}
                    className={`notification-box ${showNotificationBox ? "showbox" : ""
                      }`}
                  >
                    <ul>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      </li>
                      <li className="common-text">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              <li className="nav-item">
                <Link className="nav-link active" to="/">
                  <i className="fa-solid fa-house second-header-nav-icon"></i>
                  Home
                </Link>
              </li>

              {userRole === "user" ? <li className="nav-item">
                <Link className="nav-link active me-2" to="/find/services">
                  <i className="fa-solid fa-magnifying-glass second-header-nav-icon"></i>
                  Find Services
                </Link>
              </li> : ""}

              {!isAuth ? (
                <div className="d-flex">
                  <li className="nav-item">
                    <Link className="nav-link active" to="/signin">
                      Sign In
                    </Link>
                  </li>

                  <li>
                    <Link
                      to={"/professional/signup"}
                      className="nav-link active header-btn-blue"
                    >
                      Join I-Sit Pro Network
                    </Link>
                  </li>
                </div>
              ) : (
                <div className="dropdown header-dropdown">
                  <div
                    className="header-dropdown-icon"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="dropdown-main-text">
                      <h4>{user?.name}</h4>
                      <h6>{userRole}</h6>
                    </div>

                    {
                      user?.images[0]?.path ? <img
                        src={`${base.imageUrl}${user?.images[0]?.path}`}
                        alt=""
                      /> : <img src="/images/user-demo.jpg" />
                    }

                  </div>
                  <ul className="dropdown-menu dropdown-menu-dark">
                    {/* <div className="dropdown-main-text">
                      <h4>{user?.name}</h4>
                      <h6>{userRole}</h6>
                    </div> */}
                    <li>
                      <Link
                        className="dropdown-item"
                        to={
                          userRole === "user"
                            ? "/user/chat"
                            : userRole === "professional"
                              ? "/professional/services"
                              : userRole === "corporate"
                                ? "/corporate/dashboard"
                                : userRole === "employee" ?
                                  "/employee/chat"
                                  : userRole === "admin" ?
                                    "/admin/dashboard"
                                    : ""
                        }
                      >
                        <i className="fa-solid fa-boxes-stacked me-2"></i>
                        Dashboard
                      </Link>

                      <a
                        className="dropdown-item"
                        onClick={handleLogoutHere}
                        href="#"
                      >
                        Log Out <i className="ms-1 fas fa-power-off"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default SecondHeader;
